import { useFavorite } from "../../_hook/use-favorite";
import { toSlug } from "../../_utils/to-slug";
import { tag } from "./job-tag";

export function Job({ offer }) {
	const { favorite, toggle } = useFavorite({ offerID: offer.id });

	const url = `/pl/offers/offer/${toSlug(offer.title)}/${offer.id}/`;

	const props = { offer, toggle, favorite };

	return (
		<div className="steam-job" data-experience={offer.experience}>
			<a href={url} className="steam-job__link">
				<div className="steam-job__heading">
					<span className="steam-job__title">{offer.title}</span>

					<tag.LOCATION {...props} />
				</div>

				<div className="steam-job__meta">
					<tag.LOCATION {...props} />

					{offer.contract_type === "UMOWA_O_PRACE " && (
						<tag.CONTRACT offer={offer} />
					)}

					{offer.ukraine && <tag.UKRAINE offer={offer} />}

					{offer.salary_to && <tag.SALARY {...props} />}
				</div>

				{offer.experience && (
					<div className="steam-job__lead">{offer.lead}</div>
				)}
			</a>

			<tag.FAVORITE {...props} />
		</div>
	);
}

export function Loader() {
	return <div className="steam-job__skeleton"></div>;
}

export function EmptyState({ offerID }) {
	const { favorite, toggle } = useFavorite({ offerID });

	return (
		<div className="steam-job">
			<div className="steam-job__placeholder">Oferta wygasła</div>

			<tag.FAVORITE onClick={toggle} favorite={favorite} />
		</div>
	);
}
